<template>
    <b-modal size="xl" :title="title" ref="requestModal" modal-footer>
        <trade-form v-if="type == 'trade'" :requestInfo="requestInfo"/>
        <withdrawal-form v-if="type == 'withdrawal'"/>
        <template v-slot:modal-footer>
            <div class="text-center small">
                <small>{{footer}}</small>
            </div>
        </template>
    </b-modal>
</template>

<script>
import TradeForm from "./form/TradeForm";
import WithdrawalForm from "./form/WithdrawalForm";

export default {
    name: "Request",
    components: {
        TradeForm,
        WithdrawalForm
    },
    methods: {
        show() {
            this.$refs.requestModal.show();
        }
    },
    computed: {
        title() {
            if (this.type === 'trade') {
                return "Žiadosť o nákup/predaj aktíva";
            } else {
                return "Žiadosť o vklad/výber peňažných prostriedkov";
            }
        }
    },
    props: {
        type: {
            type: String
        },
        requestInfo: {
            type: Object
        }
    },
    data() {
        return {
            footer: "UPOZORNENIE: Pokyn na nákup/predaj aktíva je záväzným pokynom v zmysle Zmluvy o riadení portfólia. Sympatia si vyhradzuje právo na odmietnutie pokynu v prípade nedostatku prostriedkov alebo aktív na portfóliu klienta. V prípade potreby kontaktuje odd. Tradingu na tel. čísle: +421 2 3263 0711."
        }
    }
}
</script>
